// One entry per public route: what search engines and link previews see.
// Titles under 60 characters, descriptions under 160. The same table drives
// the sitemap (scripts/prerender.js reads it), so a route that is not here
// is neither prerendered nor listed.

export const SITE = {
  name: 'Flux URO',
  url: 'https://fluxuro.ai',
  tagline: 'Create, edit and animate with the best AI models in one place',
  ogImage: 'https://fluxuro.ai/images/og/flux-uro-og.jpg',
  twitter: '@fluxuro',
  docsUrl: 'https://client-api.fluxuro.ai/docs/',
  llmsUrl: 'https://client-api.fluxuro.ai/docs/llms.txt',
  mcpUrl: 'https://llm-mcp.fluxuro.ai/mcp',
};

export const PAGES = {
  '/': {
    title: 'Flux URO — AI images, video and audio in one studio',
    description: 'Generate images, edit with a prompt, animate stills into video, make songs and voice-overs. Nano Banana, Flux, Veo, Kling, Seedance, Suno and 190+ models behind one-tap workflows.',
    keywords: 'AI image generator, AI video generator, Nano Banana, Flux, Veo 3, Kling, Seedance, Suno, text to video, image to video, AI studio',
  },
  '/mcp': {
    title: 'Flux URO for ChatGPT and Claude — MCP plugin',
    description: 'Make images, videos and music inside ChatGPT or Claude by describing them. Every result comes back as a card with one-click Animate, Edit, Upscale and more. Costs shown before you spend.',
    keywords: 'ChatGPT image generation plugin, Claude MCP image video, MCP server AI video, ChatGPT app AI video, Flux URO MCP',
  },
  '/developers': {
    title: 'Flux URO API — one API for 190+ image, video and audio models',
    description: 'A single REST API for Flux, Nano Banana, GPT Image, Seedream, Veo, Kling, Seedance, MiniMax, Suno and ElevenLabs. Canonical parameters, webhooks, presigned uploads, per-model docs and llms.txt.',
    keywords: 'AI image API, AI video API, Flux API, Nano Banana API, Veo API, Kling API, Seedance API, Suno API, unified AI API',
  },
  '/pricing': {
    title: 'Flux URO pricing — pay per generation, no seats',
    description: 'Usage-based pricing for every model. Images from $0.001, video drafts from $0.07, songs from $0.35. Costs are shown before every run.',
    keywords: 'AI image generation pricing, AI video pricing, pay per generation',
  },
  '/model-costs': {
    title: 'Model costs — every AI model on Flux URO with its price',
    description: 'The price per run of every image, video and audio model on Flux URO, side by side: Flux, Nano Banana, GPT Image, Veo, Kling, Seedance, Suno and more.',
    keywords: 'AI model prices, Veo 3 price, Kling price, Nano Banana price, Flux price per image',
  },
  '/features': {
    title: 'Features — workflows, subjects, brand kits, grids and more',
    description: 'One-tap workflows, consistent characters with saved subjects, brand kits from a URL, contact-sheet grids cut into tiles, stems and remixes for songs, and a library that remembers everything.',
    keywords: 'AI workflows, consistent character AI, brand kit AI, sprite sheet generator, AI music stems',
  },
  '/about': {
    title: 'About Flux URO',
    description: 'Flux URO is a creative studio and an API that puts the best generative models behind one simple surface, for people who make things and for the apps they build.',
  },
  '/contact': {
    title: 'Contact Flux URO',
    description: 'Support, business inquiries and self-service links for Flux URO.',
  },
  '/faq': {
    title: 'Flux URO FAQ',
    description: 'What Flux URO is, what you can create, whether you need design skills, how privacy works, and how new models arrive.',
  },
  '/docs': {
    title: 'Flux URO API documentation',
    description: 'Endpoints, parameters and examples for the Flux URO API. Per-model pages and an llms.txt for agents live at client-api.fluxuro.ai/docs.',
  },
  '/privacy': { title: 'Privacy policy — Flux URO', description: 'How Flux URO handles your data and generations.', noindex: false },
  '/terms': { title: 'Terms of service — Flux URO', description: 'The terms that govern use of Flux URO.', noindex: false },
};

export const PUBLIC_ROUTES = Object.keys(PAGES);
